const urlName = '/usercenter/v2/t-b/permission'

export default (API) => ({
	// 获取用户组织
	getUserMenu(item) {
		return API({ url: `${urlName}/getMenu` })
	},
})
